module.exports = __webpack_public_path__ + "media/images/emblems/TrogenAR-eb565e7aa986a3603d42027abc7b09e7.png";